var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "reload-sl",
  "use": "reload-sl-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"reload-sl\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.933.405A.469.469 0 0 0 0 .47V3.28l.004.061c.031.24.243.421.49.407l2.813-.156.064-.008a.469.469 0 0 0 .378-.486l-.008-.063a.469.469 0 0 0-.486-.379l-1.637.09a4.062 4.062 0 1 1 .685 5.29.469.469 0 0 0-.623.702 5 5 0 1 0-.743-6.654V.469L.933.405z\" fill=\"#BFBFBF\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id